import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.gray.dark,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0, 3.5, 5.875, 3.5),
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: theme.spacing(57.625),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      height: theme.spacing(7.875),
      width: theme.spacing(7.875),
    },
  },
  actions: {
    justifyContent: 'center',
  },
  title: {
    textAlign: 'center',
    marginTop: theme.spacing(2.7125),
    ...theme.typography.h3,
  },
  wrapText: {
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  batteryContainer: {
    marginTop: theme.spacing(3.75),
  },
  batteryActions: {
    marginTop: theme.spacing(2.5),
  },
}));
